import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  select: {
    id: 'instruct.specifyLearner.select',
    defaultMessage: 'Select',
    description: 'Label for select dropdown in specify learner field',
  },
  specifyLearner: {
    id: 'instruct.specifyLearner.label',
    defaultMessage: 'Specify Learner:',
    description: 'Label for specify learner field',
  },
  specifyLearnerPlaceholder: {
    id: 'instruct.specifyLearner.placeholder',
    defaultMessage: 'Learner email address or username',
    description: 'Placeholder text for specify learner input field',
  },
  pageNotFoundHeader: {
    id: 'instruct.pageNotFound.header',
    defaultMessage: 'Page not found',
    description: 'Header for page not found error',
  },
  pageNotFoundBody: {
    id: 'instruct.pageNotFound.body',
    defaultMessage: "The page you're looking for is unavailable or there's an error in the URL. Please check the URL and try again.",
    description: 'Body text for page not found error',
  },
  pendingTasksTitle: {
    id: 'instruct.pendingTasks.section.title',
    defaultMessage: 'Pending Tasks',
    description: 'Title for the pending tasks section',
  },
  noTasksMessage: {
    id: 'instruct.pendingTasks.section.noTasks',
    defaultMessage: 'No tasks currently running.',
    description: 'Message displayed when there are no pending tasks',
  },
  taskTypeColumnName: {
    id: 'instruct.pendingTasks.table.column.taskType',
    defaultMessage: 'Task Type',
    description: 'Column name for task type in pending tasks table',
  },
  taskInputColumnName: {
    id: 'instruct.pendingTasks.table.column.taskInput',
    defaultMessage: 'Task Input',
    description: 'Column name for task input in pending tasks table',
  },
  taskIdColumnName: {
    id: 'instruct.pendingTasks.table.column.taskId',
    defaultMessage: 'Task ID',
    description: 'Column name for task ID in pending tasks table',
  },
  requesterColumnName: {
    id: 'instruct.pendingTasks.table.column.requester',
    defaultMessage: 'Requester',
    description: 'Column name for requester in pending tasks table',
  },
  taskStateColumnName: {
    id: 'instruct.pendingTasks.table.column.taskState',
    defaultMessage: 'Task State',
    description: 'Column name for task state in pending tasks table',
  },
  createdColumnName: {
    id: 'instruct.pendingTasks.table.column.created',
    defaultMessage: 'Created',
    description: 'Column name for created date in pending tasks table',
  },
  taskOutputColumnName: {
    id: 'instruct.pendingTasks.table.column.taskOutput',
    defaultMessage: 'Task Output',
    description: 'Column name for task output in pending tasks table',
  },
  durationColumnName: {
    id: 'instruct.pendingTasks.table.column.duration',
    defaultMessage: 'Duration (sec)',
    description: 'Column name for duration in pending tasks table',
  },
  statusColumnName: {
    id: 'instruct.pendingTasks.table.column.status',
    defaultMessage: 'Status',
    description: 'Column name for status in pending tasks table',
  },
  taskMessageColumnName: {
    id: 'instruct.pendingTasks.table.column.taskMessage',
    defaultMessage: 'Task Message',
    description: 'Column name for task message in pending tasks table',
  },
  downloadCSVTitle: {
    id: 'instruct.csvComponent.downloadCSVTitle',
    defaultMessage: 'Upload CSV File',
    description: 'Title for the upload CSV file section'
  },
  downloadCSVDescription: {
    id: 'instruct.csvComponent.downloadCSVDescription',
    defaultMessage: 'Only properly formatted CSV files will be accepted',
    description: 'Description for the upload CSV file section'
  },
  viewCSVTemplate: {
    id: 'instruct.csvComponent.viewCSVTemplate',
    defaultMessage: 'View Template',
    description: 'Label for the view CSV template link'
  },
  uploadingFileMessage: {
    id: 'instruct.csvComponent.uploadingFileMessage',
    defaultMessage: 'File chosen: {fileName}',
    description: 'Message displayed when a file is being uploaded, with the file name included'
  },
  change: {
    id: 'instruct.specifyLearner.change',
    defaultMessage: 'Change',
    description: 'Label for change button in specify learner field',
  },
  learnerNotFound: {
    id: 'instruct.specifyLearner.learnerNotFound',
    defaultMessage: 'Could not find student matching identifier: {identifier}',
    description: 'Error message displayed when a learner cannot be found based on the provided identifier (email or username)',
  },
  problemNotFound: {
    id: 'instruct.specifyProblemField.problemNotFound',
    defaultMessage: 'Could not find problem matching identifier: {identifier}',
    description: 'Error message displayed when a problem cannot be found based on the provided identifier',
  },
  searchPlaceholder: {
    id: 'instruct.usernameFilter.searchPlaceholder',
    defaultMessage: 'Search By Username or Email',
    description: 'Placeholder text for the username filter input',
  },
  problemLocationPlaceholder: {
    id: 'instruct.specifyProblemField.locationPlaceholder',
    defaultMessage: 'Problem location',
    description: 'Placeholder text for problem location input',
  },
  problemLocationInfoIconLabel: {
    id: 'instruct.specifyProblemField.infoIconLabel',
    defaultMessage: 'Example format for problem location',
    description: 'Aria label for the info icon next to the problem location input',
  },
  problemLocationTooltip: {
    id: 'instruct.specifyProblemField.locationTooltip',
    defaultMessage: 'Example: block-v1:edX+DemoX+2015+type@problem+block@618c5933b8b544e4a4cc103d3e508378',
    description: 'Tooltip text showing an example problem location format',
  },
  selectedProblem: {
    id: 'instruct.specifyProblemField.selectedProblem',
    defaultMessage: 'Selected Problem:',
    description: 'Label for specify problem field when a problem has been selected',
  },
  learnerNotEnrolled: {
    id: 'instruct.specifyLearner.learnerNotEnrolled',
    defaultMessage: '{identifier} is not enrolled in this course',
    description: 'Error message displayed when a learner is found based on the provided identifier (email or username) but is not enrolled in the course',
  },
  selectedLearner: {
    id: 'instruct.specifyLearner.selectedLearner',
    defaultMessage: 'Selected Learner:',
    description: 'Label for specify learner field when a learner has been selected',
  },
  learnerGenericError: {
    id: 'instruct.specifyLearner.learnerGenericError',
    defaultMessage: 'An error occurred while looking up {identifier}. Please try again.',
    description: 'Generic error message displayed when there is an error looking up a learner based on the provided identifier (email or username)',
  }
});

export default messages;
